import React, { useState, useContext } from "react";
import "./Register.css";
import API from "../api/axios.js";
import { AuthContext } from "../context/AuthContext.js";
import { useNavigate } from "react-router-dom";

const Register = () => {
  const navigate = useNavigate();
  const { setToken, setUser } = useContext(AuthContext);

  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    companyName: "",
    number: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await API.post("/auth/register", form);
      setToken(res.data.token);
      setUser(res.data.user);
      navigate("/dashboard");
    } catch (error) {
      alert(error.response?.data?.message || "Registration failed");
    }
  };

  return (
    <div className="register-page">

      {/* LEFT: BUSINESS CONTEXT */}
      <section className="register-intro">
        <div className="intro-content">
          <div className="brand">
            <h1>TruckBase</h1>
            <span>Transport Management Platform</span>
          </div>

          <h2>Set up your transport operations digitally</h2>

          <p>
            Create your TruckBase account to manage trips, vehicles, drivers,
            billing, and operational records in one secure system.
          </p>

          <ul className="intro-points">
            <li>Centralized transport and fleet records</li>
            <li>Professional bilty and invoice generation</li>
            <li>Clear reporting for daily operations</li>
            <li>Designed for transport business owners</li>
          </ul>

          <div className="trust-bar">
            <div>
              <strong>Structured</strong>
              <span>Operations</span>
            </div>
            <div>
              <strong>Secure</strong>
              <span>Data Handling</span>
            </div>
            <div>
              <strong>Reliable</strong>
              <span>System Access</span>
            </div>
          </div>
        </div>
      </section>

      {/* RIGHT: REGISTER FORM */}
      <section className="register-panel">
        <div className="register-card">
          <h3>Create an account</h3>
          <p className="register-subtitle">
            Provide your business details to get started
          </p>

          <form onSubmit={handleSubmit}>
            <label>Full name</label>
            <input
              type="text"
              placeholder="Your full name"
              onChange={(e) =>
                setForm({ ...form, name: e.target.value })
              }
            />

            <label>Email address</label>
            <input
              type="email"
              placeholder="name@company.com"
              onChange={(e) =>
                setForm({ ...form, email: e.target.value })
              }
            />

            <label>Password</label>
            <input
              type="password"
              placeholder="Create a password"
              onChange={(e) =>
                setForm({ ...form, password: e.target.value })
              }
            />

            <label>Company name</label>
            <input
              type="text"
              placeholder="Transport company name"
              onChange={(e) =>
                setForm({ ...form, companyName: e.target.value })
              }
            />

            <label>Mobile number</label>
            <input
              type="text"
              placeholder="Contact number"
              onChange={(e) =>
                setForm({ ...form, number: e.target.value })
              }
            />

            <button type="submit">Create account</button>
          </form>

          <p className="login-link" onClick={() => navigate("/login")}>
            Already registered? Sign in
          </p>
        </div>
      </section>

    </div>
  );
};

export default Register;
